import { render, staticRenderFns } from "./ThePrivacyPolicyLayout.vue?vue&type=template&id=6fa4aefb&scoped=true&"
import script from "./ThePrivacyPolicyLayout.vue?vue&type=script&lang=js&"
export * from "./ThePrivacyPolicyLayout.vue?vue&type=script&lang=js&"
import style0 from "./ThePrivacyPolicyLayout.vue?vue&type=style&index=0&id=6fa4aefb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa4aefb",
  null
  
)

export default component.exports